export default "__VITE_ASSET__CUHGsalY__"